module.exports = " <div class=ui> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <paco-switch></paco-switch> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/SwitchView.vue
// module id = 158
// module chunks = 1